// js/custom-element/section/product-list/product-item.js
var ProductItem = class extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.product-item-meta__swatch-list .color-swatch__radio').forEach((radio) =>
      radio.addEventListener('change', this._onColorSwatchChanged.bind(this))
    );
    this.primaryImageList = Array.from(this.querySelectorAll(".product-item__primary-image"));
    this.hoverImage = this.querySelector(".product-item__secondary-image");
  }
  connectedCallback() {
    this.primaryImageList = Array.from(this.querySelectorAll(".product-item__primary-image"));
  }
  async _onColorSwatchChanged(event, target) {
    console.log('colorChange' + event.target);
    Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
      let url;
      if (link.tagName === "A") {
        url = new URL(link.href);
        console.log('url1:' + url)
      } else {
        url = new URL(link.getAttribute("href"), `https://${window.themeVariables.routes.host}`);
        console.log('url2:' + url);
      }
      url.searchParams.set("variant", event.target.getAttribute("data-variant-id"));
      link.setAttribute("href", url.toString());
    });
    if (event.target.hasAttribute("data-variant-featured-media")) {
      console.log('swap image')
      const newImage = this.primaryImageList.find((image) => image.getAttribute("data-media-id") === event.target.getAttribute("data-variant-featured-media"));
      console.log('image:' + newImage.getAttribute('src'));
      newImage.setAttribute("loading", "eager");
      const onImageLoaded = newImage.complete ? Promise.resolve() : new Promise((resolve) => newImage.onload = resolve);
      await onImageLoaded;
      newImage.removeAttribute("hidden");
      newImage.classList.add('new-top');
      let properties = {};
      
      this.primaryImageList
      .filter((image) => image.classList.contains("product-item__primary-image") && image !== newImage)
      .forEach((image) => {
        image.setAttribute("hidden", "");
        image.classList.remove("new-top");
      });
      this.hoverImage.setAttribute("hidden", "");

    }
  }
  _onColorSwatchHovered(event, target) {
    console.log('colorswatchhover!')
    const input = target.previousElementSibling;
    if (input.hasAttribute("data-variant-featured-media")) {
      const newImage = this.primaryImageList.find((image) => image.getAttribute("data-media-id") === input.getAttribute("data-variant-featured-media"));
      newImage.setAttribute("loading", "eager");
    }
  }
};
customElements.define("product-item", ProductItem);


class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    console.log('[CollectionTabs] Initializing for section:', this.dataset.sectionId);
    this.tabButtons = this.querySelectorAll('.collection-tab__button');
    this.tabContents = this.querySelectorAll('.collection-tab__content');
    
    console.log('[CollectionTabs] Found tab buttons:', this.tabButtons.length);
    console.log('[CollectionTabs] Found tab contents:', this.tabContents.length);
    
    if (!this.tabButtons.length) {
      console.warn('[CollectionTabs] No tab buttons found, component not initialized');
      return;
    }
    
    this.init();
  }

  init() {
    console.log('[CollectionTabs] Binding click events to tabs');
    
    this.tabButtons.forEach((button, index) => {
      console.log(`[CollectionTabs] Setting up button ${index + 1}:`, button.textContent.trim(), 'Target:', button.dataset.target);
      
      button.addEventListener('click', (event) => {
        console.log(`[CollectionTabs] Button clicked:`, button.textContent.trim());
        this.handleTabClick(event);
      });
    });
  }

  handleTabClick(event) {
    const clickedButton = event.currentTarget;
    const targetId = clickedButton.dataset.target;
    
    console.log('[CollectionTabs] Tab clicked:', clickedButton.textContent.trim());
    console.log('[CollectionTabs] Target ID:', targetId);
    
    // Verify target exists
    const targetElement = this.querySelector(`#${targetId}`);
    if (!targetElement) {
      console.error(`[CollectionTabs] Target element #${targetId} not found!`);
      return;
    }
    
    console.log('[CollectionTabs] Found target element:', targetElement.id);
    
    // Remove active class from all buttons and contents in this instance
    console.log('[CollectionTabs] Deactivating all tabs');
    this.tabButtons.forEach(btn => {
      btn.classList.remove('is-active');
    });
    
    this.tabContents.forEach(content => {
      content.classList.remove('is-active');
    });
    
    // Add active class to clicked button and its content
    console.log('[CollectionTabs] Activating selected tab');
    clickedButton.classList.add('is-active');
    targetElement.classList.add('is-active');
    
    // Log final state
    console.log('[CollectionTabs] Active button:', clickedButton.textContent.trim());
    console.log('[CollectionTabs] Active content:', targetElement.id);
    
    // Reinitialize sliders if needed
    const activeSlider = targetElement.querySelector('slider-component');
    if (activeSlider) {
      console.log('[CollectionTabs] Refreshing slider component');
      // Dispatch a resize event to help sliders recalculate
      window.dispatchEvent(new Event('resize'));
    }
  }
}

customElements.define('collection-tabs', CollectionTabs);

// size guide tabs
class SizeGuideTabs extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('.size-guide-tab__button');
    this.tabContents = this.querySelectorAll('.size-guide-tab__content');
    
    if (!this.tabButtons.length) {
      return;
    }
    
    this.init();
    this.initUnitToggle();
  }

  init() {
    
    this.tabButtons.forEach((button, index) => {
      
      button.addEventListener('click', (event) => {
        this.handleTabClick(event);
      });
    });
    
    // Activate first tab by default
    if (this.tabButtons.length > 0) {
      this.tabButtons[0].classList.add('is-active');
    }
    
    if (this.tabContents.length > 0) {
      this.tabContents[0].classList.add('is-active');
    }
  }

  handleTabClick(event) {
  const clickedButton = event.currentTarget;
  const targetId = clickedButton.dataset.target;
  
  
  // Verify target exists
  const targetElement = this.querySelector(`#${targetId}`);
  if (!targetElement) {
    return;
  }
  
  
  // Remove active class from all buttons and contents in this instance
  this.tabButtons.forEach(btn => {
    btn.classList.remove('is-active');
    btn.setAttribute('aria-selected', 'false');
  });

  this.tabContents.forEach(content => {
    content.classList.remove('is-active');
  });

  // Add active class to clicked button and its content
  clickedButton.classList.add('is-active');
  clickedButton.setAttribute('aria-selected', 'true');
  targetElement.classList.add('is-active');
  
  // INITIALIZE DEFERRED MEDIA IN THE NEW ACTIVE TAB
  targetElement.querySelectorAll('deferred-media').forEach(element => {
    if (!element.initialized) {
      customElements.upgrade(element);
      element.initialized = true;
    }
  });
  
  
  // Check if the new active tab has unit conversion
  this.checkForUnitToggle(targetElement);
}
  
  // Initialize the unit toggle feature for CM/IN conversion
  initUnitToggle() {
    
    // Check if the first tab (default active) has unit conversion
    if (this.tabContents.length > 0) {
      this.checkForUnitToggle(this.tabContents[0]);
    }
  }
  
  // Check if the tab has unit conversion toggle and initialize if needed
  checkForUnitToggle(tabContent) {
    const unitToggle = tabContent.querySelector('[data-unit-toggle]');
    if (!unitToggle) {
      return;
    }
    
    
    const cmIndicator = unitToggle.querySelector('[data-unit-cm]');
    const inIndicator = unitToggle.querySelector('[data-unit-in]');
    const liveFeedback = tabContent.querySelector('[aria-live="polite"]');
    const unitHeaders = tabContent.querySelectorAll('th:nth-child(3)');
    const measurementCells = tabContent.querySelectorAll('td[data-inches]');
    
    // Set initial state - CM is default
    let currentUnit = 'cm';
    unitToggle.setAttribute('aria-pressed', 'false');
    
    // Initialize the table with CM values
    this.updateMeasurements(tabContent, 'cm', unitHeaders, measurementCells);
    
    // Clear existing event listeners if any
    unitToggle.removeEventListener('click', unitToggle.toggleHandler);
    unitToggle.removeEventListener('keydown', unitToggle.keyHandler);
    
    // Toggle units when button is clicked
    unitToggle.toggleHandler = () => {
      const isPressed = unitToggle.getAttribute('aria-pressed') === 'true';
      unitToggle.setAttribute('aria-pressed', !isPressed);
      
      if (currentUnit === 'cm') {
        // Switch to inches
        currentUnit = 'inches';
        cmIndicator.classList.remove('active');
        inIndicator.classList.add('active');
        this.updateMeasurements(tabContent, 'inches', unitHeaders, measurementCells);
        if (liveFeedback) liveFeedback.textContent = 'Showing measurements in inches';
      } else {
        // Switch to centimeters
        currentUnit = 'cm';
        cmIndicator.classList.add('active');
        inIndicator.classList.remove('active');
        this.updateMeasurements(tabContent, 'cm', unitHeaders, measurementCells);
        if (liveFeedback) liveFeedback.textContent = 'Showing measurements in centimeters';
      }
    };
    
    // Add keyboard support
    unitToggle.keyHandler = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        unitToggle.toggleHandler();
      }
    };
    
    unitToggle.addEventListener('click', unitToggle.toggleHandler);
    unitToggle.addEventListener('keydown', unitToggle.keyHandler);
    
  }
  
  // Update measurement displays based on selected unit
  updateMeasurements(tabContent, unit, unitHeaders, measurementCells) {
    
    // Update table headers
    unitHeaders.forEach(header => {
      header.textContent = unit === 'cm' ? 'Centimeters' : 'Inches';
    });
    
    // Update measurement cells based on unit
    measurementCells.forEach(cell => {
      const inchesValue = parseFloat(cell.getAttribute('data-inches'));
      
      if (unit === 'cm') {
        // Convert inches to centimeters (rounded to nearest whole number)
        const cmValue = Math.round(inchesValue * 2.54);
        cell.textContent = cmValue;
        cell.setAttribute('aria-label', `${cmValue} centimeters`);
      } else {
        // Format the inches value with proper fractions
        cell.textContent = this.formatInches(inchesValue);
        cell.setAttribute('aria-label', `${this.describeInches(inchesValue)} inches`);
      }
      
      // Add changing class for animation
      cell.classList.add('changing');
      setTimeout(() => {
        cell.classList.remove('changing');
      }, 300);
    });
  }
  
  // Helper function to format inch values with nice fractions
  formatInches(value) {
    const whole = Math.floor(value);
    const fraction = value - whole;
    
    if (fraction === 0) {
      return whole.toString();
    }
    
    // Format common fractions with special characters
    if (Math.abs(fraction - 0.25) < 0.01) return `${whole}¼`; 
    if (Math.abs(fraction - 0.5) < 0.01) return `${whole}½`;
    if (Math.abs(fraction - 0.75) < 0.01) return `${whole}¾`;
    if (Math.abs(fraction - 0.125) < 0.01) return `${whole}⅛`;
    if (Math.abs(fraction - 0.375) < 0.01) return `${whole}⅜`;
    if (Math.abs(fraction - 0.625) < 0.01) return `${whole}⅝`;
    if (Math.abs(fraction - 0.875) < 0.01) return `${whole}⅞`;
    
    // For other fractions, use up to 2 decimal places
    return value.toFixed(2);
  }
  
  // Helper function for screen reader descriptions of inch values
  describeInches(value) {
    const whole = Math.floor(value);
    const fraction = value - whole;
    
    if (fraction === 0) {
      return whole.toString();
    }
    
    // Describe common fractions in words for screen readers
    if (Math.abs(fraction - 0.25) < 0.01) return `${whole} and one quarter`; 
    if (Math.abs(fraction - 0.5) < 0.01) return `${whole} and one half`;
    if (Math.abs(fraction - 0.75) < 0.01) return `${whole} and three quarters`;
    if (Math.abs(fraction - 0.125) < 0.01) return `${whole} and one eighth`;
    if (Math.abs(fraction - 0.375) < 0.01) return `${whole} and three eighths`;
    if (Math.abs(fraction - 0.625) < 0.01) return `${whole} and five eighths`;
    if (Math.abs(fraction - 0.875) < 0.01) return `${whole} and seven eighths`;
    
    // For other fractions, use decimal description
    return value.toFixed(2);
  }
}

customElements.define('size-guide-tabs', SizeGuideTabs);

// for size chart page not using tabs
// Standalone unit toggle for size guides without tabs
class SizeGuideUnitToggle extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const unitToggle = this.querySelector('[data-unit-toggle]');
    if (!unitToggle) {
      return;
    }

    const cmIndicator = unitToggle.querySelector('[data-unit-cm]');
    const inIndicator = unitToggle.querySelector('[data-unit-in]');
    const liveFeedback = this.querySelector('[aria-live="polite"]');
    const unitHeaders = this.querySelectorAll('th:nth-child(3)');
    const measurementCells = this.querySelectorAll('td[data-inches]');
    
    // Set initial state - CM is default
    let currentUnit = 'cm';
    unitToggle.setAttribute('aria-pressed', 'false');
    
    // Initialize the table with CM values
    this.updateMeasurements('cm', unitHeaders, measurementCells);
    
    // Clear existing event listeners if any
    unitToggle.removeEventListener('click', unitToggle.toggleHandler);
    unitToggle.removeEventListener('keydown', unitToggle.keyHandler);
    
    // Toggle units when button is clicked
    unitToggle.toggleHandler = () => {
      const isPressed = unitToggle.getAttribute('aria-pressed') === 'true';
      unitToggle.setAttribute('aria-pressed', !isPressed);
      
      if (currentUnit === 'cm') {
        // Switch to inches
        currentUnit = 'inches';
        cmIndicator.classList.remove('active');
        inIndicator.classList.add('active');
        this.updateMeasurements('inches', unitHeaders, measurementCells);
        if (liveFeedback) liveFeedback.textContent = 'Showing measurements in inches';
      } else {
        // Switch to centimeters
        currentUnit = 'cm';
        cmIndicator.classList.add('active');
        inIndicator.classList.remove('active');
        this.updateMeasurements('cm', unitHeaders, measurementCells);
        if (liveFeedback) liveFeedback.textContent = 'Showing measurements in centimeters';
      }
    };
    
    // Add keyboard support
    unitToggle.keyHandler = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        unitToggle.toggleHandler();
      }
    };
    
    unitToggle.addEventListener('click', unitToggle.toggleHandler);
    unitToggle.addEventListener('keydown', unitToggle.keyHandler);
  }
  
  // Update measurement displays based on selected unit
  updateMeasurements(unit, unitHeaders, measurementCells) {
    // Update table headers
    unitHeaders.forEach(header => {
      header.textContent = unit === 'cm' ? 'Centimeters' : 'Inches';
    });
    
    // Update measurement cells based on unit
    measurementCells.forEach(cell => {
      const inchesValue = parseFloat(cell.getAttribute('data-inches'));
      
      if (unit === 'cm') {
        // Convert inches to centimeters (rounded to nearest whole number)
        const cmValue = Math.round(inchesValue * 2.54);
        cell.textContent = cmValue;
        cell.setAttribute('aria-label', `${cmValue} centimeters`);
      } else {
        // Format the inches value with proper fractions
        cell.textContent = this.formatInches(inchesValue);
        cell.setAttribute('aria-label', `${this.describeInches(inchesValue)} inches`);
      }
      
      // Add changing class for animation
      cell.classList.add('changing');
      setTimeout(() => {
        cell.classList.remove('changing');
      }, 300);
    });
  }
  
  // Helper function to format inch values with nice fractions
  formatInches(value) {
    const whole = Math.floor(value);
    const fraction = value - whole;
    
    if (fraction === 0) {
      return whole.toString();
    }
    
    // Format common fractions with special characters
    if (Math.abs(fraction - 0.25) < 0.01) return `${whole}¼`; 
    if (Math.abs(fraction - 0.5) < 0.01) return `${whole}½`;
    if (Math.abs(fraction - 0.75) < 0.01) return `${whole}¾`;
    if (Math.abs(fraction - 0.125) < 0.01) return `${whole}⅛`;
    if (Math.abs(fraction - 0.375) < 0.01) return `${whole}⅜`;
    if (Math.abs(fraction - 0.625) < 0.01) return `${whole}⅝`;
    if (Math.abs(fraction - 0.875) < 0.01) return `${whole}⅞`;
    
    // For other fractions, use up to 2 decimal places
    return value.toFixed(2);
  }
  
  // Helper function for screen reader descriptions of inch values
  describeInches(value) {
    const whole = Math.floor(value);
    const fraction = value - whole;
    
    if (fraction === 0) {
      return whole.toString();
    }
    
    // Describe common fractions in words for screen readers
    if (Math.abs(fraction - 0.25) < 0.01) return `${whole} and one quarter`; 
    if (Math.abs(fraction - 0.5) < 0.01) return `${whole} and one half`;
    if (Math.abs(fraction - 0.75) < 0.01) return `${whole} and three quarters`;
    if (Math.abs(fraction - 0.125) < 0.01) return `${whole} and one eighth`;
    if (Math.abs(fraction - 0.375) < 0.01) return `${whole} and three eighths`;
    if (Math.abs(fraction - 0.625) < 0.01) return `${whole} and five eighths`;
    if (Math.abs(fraction - 0.875) < 0.01) return `${whole} and seven eighths`;
    
    // For other fractions, use decimal description
    return value.toFixed(2);
  }
}

customElements.define('size-guide-unit-toggle', SizeGuideUnitToggle);

//change klaviyo on mobile prod cards
function adjustKlaviyoReviewText() {
  const starWraps = document.querySelectorAll('.klaviyo-star-wrap');

  starWraps.forEach((wrap) => {
    const reviewTextEl = wrap.querySelector('.kl_reviews__star_rating_widget__label');
    
    if (reviewTextEl) {
      const match = reviewTextEl.textContent.match(/(\d+)\s*reviews?/i);
      if (match) {
        const count = match[1];
        const isMobile = window.matchMedia('(max-width: 750px)').matches;

        const newText = isMobile ? `(${count})` : `(${count} Reviews)`;
        // Only write when changed, so the MutationObserver below doesn't loop
        if (reviewTextEl.textContent !== newText) reviewTextEl.textContent = newText;
      }
    }

    // Show entire star wrap once Klaviyo has rendered into it
    if (wrap.querySelector('.kl_reviews__star_rating_widget') && wrap.style.visibility !== 'visible') {
      wrap.style.visibility = 'visible';
    }
  });
}


//Run on DOM load, and whenever Klaviyo renders widgets into new/replaced
//product cards (e.g. after facet filtering, sorting, pagination)
document.addEventListener('DOMContentLoaded', function () {
  adjustKlaviyoReviewText();
  setTimeout(adjustKlaviyoReviewText, 1500);

  let klaviyoAdjustQueued = false;
  const klaviyoObserver = new MutationObserver(() => {
    if (klaviyoAdjustQueued) return;
    klaviyoAdjustQueued = true;
    requestAnimationFrame(() => {
      klaviyoAdjustQueued = false;
      adjustKlaviyoReviewText();
    });
  });
  klaviyoObserver.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('resize', adjustKlaviyoReviewText);
});

class ReadMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let _self = this;

    const readMoreButton = _self.querySelector('.read-more-button');
    const description = _self.querySelector('.expanded-description');
    readMoreButton.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('read more click');
      if (description.classList.contains('expanded')) {
        description.classList.remove('expanded');
        readMoreButton.textContent = 'Read more';
        // var anchor = _self.querySelector('#description--{{ section.id }}');
        var offset = 0; // sticky nav height
        window.scroll({ top: (_self.offsetTop - offset), left: 0, behavior: 'smooth' });
      } else {
        description.classList.add('expanded');
        readMoreButton.textContent = 'Read less';
      }
    });
  }
}

customElements.define('read-more', ReadMore);

function fixPlusSpacing() {
    const headings = document.querySelectorAll('.image-with-text__heading');
    
    headings.forEach(heading => {
        let content = heading.innerHTML;
        content = content.replace(/(\d+)\+/g, '$1<span class="plus-tight">+</span>');
        heading.innerHTML = content;
    });
}

document.addEventListener('DOMContentLoaded', fixPlusSpacing);
setTimeout(fixPlusSpacing, 100);